import { dollarToString } from '../../../../lib/currency-utils';
import { INDIVIDUAL_DISTRIBUTION_TEXT, INDIVIDUAL_INVESTMENT_YEAR_TEXT, INDIVIDUAL_POTENTIAL_AMOUNT_TEXT } from '../constants/constants';
import { taxableCompoundGrowth, taxableRetirementDistribution, taxableSinker } from './calculator';
import { getCadence, getContribution, getDistributionRate, getInterestRate } from './helpers';

const getPotentialAmount = (contributionDataSet, investmentYears) => {
    if(contributionDataSet.length === 0) return 0;
    const decimalPart = investmentYears - Math.floor(investmentYears);
    const half = 0.5;

    let dataSetIndex = 0;
    if(decimalPart > half) {
        dataSetIndex = 1;
    }

    const potentialAmount = dollarToString(contributionDataSet[Math.trunc(investmentYears) + dataSetIndex], true);
    return potentialAmount;
}

export const getTaxableRetirmentDistributions = (contributionItem, initialPortfolioValue, numInvestmentYears, numDistributionYears, interestRate) => {
    // E10 -> Investment Years
    // E14 -> Contribution
    // E15 -> Cadence
    // E18 -> Distribution Years
    // E19 -> E18 + E10

    const interestRateValue = getInterestRate(interestRate);
    // distributionRate may be editable later. in that case store distribution rate in react context and then pass it in
    // then use distribution rate directly in getDistributionRate Function
    const distributionRateValue = getDistributionRate(interestRate / 2);
    const contribution = getContribution(contributionItem);
    const cadence = getCadence(contributionItem);
    const { compoundPortfolio, contributions } = taxableCompoundGrowth(initialPortfolioValue, numInvestmentYears, interestRateValue, contribution, cadence);
    const lastCompoundingYear = compoundPortfolio[compoundPortfolio.length - 1];
    const { distributionPortfolio, distributions } = taxableSinker(initialPortfolioValue, lastCompoundingYear, numDistributionYears, distributionRateValue);

    const data = taxableRetirementDistribution(initialPortfolioValue, compoundPortfolio, contributions, distributionPortfolio, distributions);
    const potentialAmount = getPotentialAmount(data.contributionDistributionPortfolio, numInvestmentYears);

    const stats = {
        initialPortfolioValue,
        numInvestmentYears,
        numDistributionYears,
        potentialAmount,
        contribution,
        investmentYearsText: INDIVIDUAL_INVESTMENT_YEAR_TEXT,
        potentialAmountText: INDIVIDUAL_POTENTIAL_AMOUNT_TEXT,
        distributionYearsText: INDIVIDUAL_DISTRIBUTION_TEXT,
    }

    return { data, stats };
}